import { forwardRef, type SVGProps } from 'react';

export const DlnCheckErrorIcon = forwardRef<
  SVGSVGElement,
  SVGProps<SVGSVGElement>
>(function DlnCheckErrorIcon(props, ref) {
  return (
    <svg
      ref={ref}
      fill="none"
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_1621_10933)">
        <circle cx="24" cy="24" r="22" stroke="currentColor" strokeWidth="4" />
        <path
          clipRule="evenodd"
          d="M16.587 33.412C16.979 33.804 17.45 34 18 34H30C30.5493 34.0007 31.02 33.805 31.412 33.413C31.804 33.021 32 32.55 32 32V20L26 14H18C17.4507 13.9993 16.98 14.195 16.588 14.587C16.196 14.979 16 15.45 16 16V32C15.9993 32.5493 16.195 33.02 16.587 33.412ZM30 21H25V16L30 21ZM21.5728 24C21.4208 24 21.2752 24.0603 21.1677 24.1677C21.0603 24.2752 21 24.4208 21 24.5728C21 24.7247 21.0603 24.8703 21.1677 24.9778L23.1934 27.0035L21.1677 29.0291C21.0634 29.1372 21.0056 29.2819 21.0069 29.4321C21.0082 29.5823 21.0685 29.726 21.1747 29.8322C21.2809 29.9384 21.4246 29.9987 21.5748 30C21.725 30.0013 21.8697 29.9435 21.9778 29.8392L24.0035 27.8135L26.0291 29.8392C26.1372 29.9435 26.2819 30.0013 26.4321 30C26.5823 29.9987 26.726 29.9384 26.8322 29.8322C26.9384 29.726 26.9987 29.5823 27 29.4321C27.0013 29.2819 26.9435 29.1372 26.8392 29.0291L24.8135 27.0035L26.8392 24.9778C26.9435 24.8697 27.0013 24.725 27 24.5748C26.9987 24.4246 26.9384 24.2809 26.8322 24.1747C26.726 24.0685 26.5823 24.0082 26.4321 24.0069C26.2819 24.0056 26.1372 24.0634 26.0291 24.1677L24.0035 26.1934L21.9778 24.1677C21.8703 24.0603 21.7247 24 21.5728 24Z"
          fill="currentColor"
          fillRule="evenodd"
        />
      </g>
      <defs>
        <clipPath id="clip0_1621_10933">
          <rect fill="white" height="48" width="48" />
        </clipPath>
      </defs>
    </svg>
  );
});
